"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.82 9.884a.5.5 0 0 0-.64-.768l-3 2.5a.5.5 0 0 0 0 .768l3 2.5a.5.5 0 0 0 .64-.768L11.281 12z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
  })]
}), 'PreviousCircle');
